"use strict";
/*
 * Created on 19. 4. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var index_1 = require("./index");
/**
 * Utilities for tree nodes identification and traversal.
 * @author Radek Beran
 * @author PKr
 */


var TreeNodes =
/*#__PURE__*/
function () {
  function TreeNodes() {
    _classCallCheck(this, TreeNodes);
  }

  _createClass(TreeNodes, null, [{
    key: "getNodeIdsWithPredecessors",

    /**
     * Returns given node ids including their predecessors (parents on the whole path to the root).
     * @param nodeIds input node ids
     * @param idsToParentIds mapping of node ids to parent node ids
     */
    value: function getNodeIdsWithPredecessors(nodeIds, idsToParentIds) {
      var predecessors = nodeIds;

      if (!nodeIds.isEmpty()) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = nodeIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var nodeId = _step.value;
            var currentNodeId = nodeId;

            while (idsToParentIds.has(currentNodeId)) {
              var parentId = idsToParentIds.get(currentNodeId);

              if (!parentId) {
                break;
              }

              predecessors = predecessors.add(parentId);
              currentNodeId = parentId;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return predecessors;
    }
    /**
     * Returns given node ids including their successors (subtrees) recursively.
     * @param nodeIds
     * @param idsToParentIds mapping of node ids to parent node ids
     */

  }, {
    key: "getNodeIdsWithSuccessors",
    value: function getNodeIdsWithSuccessors(nodeIds, idsToParentIds) {
      if (nodeIds.isEmpty()) {
        return immutable_1.Set();
      }

      var parentIdsToSuccessorIds = index_1.Utils.reverseMapping(idsToParentIds);
      return TreeNodes.getNodeIdsWithSuccessorsRec(nodeIds, parentIdsToSuccessorIds);
    }
    /**
     * Returns given node ids including their successors (subtrees) recursively.
     * @param nodeIds
     * @param parentIdsToSuccessorIds mapping of parent node ids to their successor node ids
     */

  }, {
    key: "getNodeIdsWithSuccessorsRec",
    value: function getNodeIdsWithSuccessorsRec(nodeIds, parentIdsToSuccessorIds) {
      var successors = nodeIds;

      if (!nodeIds.isEmpty()) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = nodeIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var nodeId = _step2.value;
            var successorIds = parentIdsToSuccessorIds.get(nodeId);

            if (successorIds) {
              successors = successors.union(this.getNodeIdsWithSuccessorsRec(successorIds, parentIdsToSuccessorIds));
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return successors;
    }
  }]);

  return TreeNodes;
}();

exports.TreeNodes = TreeNodes;